import React from 'react';

import { useChildComponent } from '@gogame/hooks-ts';

import { DummyCampaignFormCreate } from 'scenes/Campaigns/GGCampaigns/components/CampaignForm';
import { useLoadSA } from 'scenes/SpendAdjustments/data';
import {
  useCreateSA,
  useUpdateSA,
  useCheckSA,
} from 'scenes/SpendAdjustments/data/mutations';

import SpendAdjustmentsForm from './SpendAdjustmentsForm';
import { CURRENCY, ADJUSTMENT_REASON } from './constants';

export const SpendAdjustmentsFormCreate = ({
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [createSA, { isLoading: isCreating }] = useCreateSA();
  const [checkSA, { isLoading: isChecking }] = useCheckSA();

  const [childComponent, showChildComponent] = useChildComponent();

  const initialValues = {
    [CURRENCY]: 'usd',
    [ADJUSTMENT_REASON]: 2,
  };

  /* eslint-disable-next-line */
  const handleSubmit = async ({ stats: _, ...values }) => {
    const dummyCampaignRequired = await checkSA(values);

    if (dummyCampaignRequired) {
      showChildComponent(DummyCampaignFormCreate, {
        initialValues: { ...values },
        onSubmit: onClose,
      });
    } else {
      const spendAdjustment = await createSA(values);
      onSubmit(spendAdjustment);
    }
  };

  return (
    <SpendAdjustmentsForm
      title={'Add Spend Adjustment'}
      initialValues={initialValues}
      loading={isCreating || isChecking}
      onClose={onClose}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
    >
      {childComponent}
    </SpendAdjustmentsForm>
  );
};

export const SpendAdjustmentsFormEdit = ({
  id,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const { data, isLoading } = useLoadSA(id);
  const [updateSA, { isLoading: isUpdating }] = useUpdateSA();

  /* eslint-disable-next-line */
  const handleSubmit = async ({ stats: _, ...values }) => {
    return updateSA(values).then((spend) => onSubmit(spend));
  };

  return (
    <SpendAdjustmentsForm
      title={'Edit Spend Adjustment'}
      entityId={id}
      initialValues={data}
      loading={isLoading || isUpdating}
      active={!!data}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      onClose={onClose}
      onExited={onExited}
      open={open}
    />
  );
};

export const SpendAdjustmentsFormCopy = ({
  id,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const { data = {}, isLoading } = useLoadSA(id);

  const [childComponent, showChildComponent] = useChildComponent();
  const [createSA, { isLoading: isCreating }] = useCreateSA();
  const [checkSA, { isLoading: isChecking }] = useCheckSA();

  const handleSubmit = async ({
    /* eslint-disable */
    id: _,
    stats: __,
    cluster: ___,
    /* eslint-enable */
    ...values
  }) => {
    const dummyCampaignRequired = await checkSA(values);

    if (dummyCampaignRequired) {
      showChildComponent(DummyCampaignFormCreate, {
        initialValues: { ...values },
        onCloseSA: onClose,
      });
    } else {
      const response = await createSA(values);
      onSubmit(response);
    }
  };

  const getInitialValues = (data) => {
    const { id, ...initialValues } = data;
    return initialValues;
  };

  return (
    <SpendAdjustmentsForm
      title={'Add Spend Adjustment'}
      initialValues={getInitialValues(data)}
      loading={isLoading || isCreating || isChecking}
      active={!!data}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      onClose={onClose}
      onExited={onExited}
      open={open}
    >
      {childComponent}
    </SpendAdjustmentsForm>
  );
};
